import React from "react";
import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";
import { Common } from "../../utils/common";

const Highcharts = window.Highcharts;

function TotalTextsChart({ data, count }) {
  const chartData = data.map((data) => [data.day, data.texts]);
  const chartDataX = data.map((data) => [data.day]);

  const chartOptions = {
    chart: {
      type: "spline",
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "Total Text Conversion by Day",
      style: {
        fontWeight: "bold",
        fontSize: "14",
      },
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      categories: chartDataX,
    },
    yAxis: {
      title: {
        text: "Text Count",
      },
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: false,
      },
    },
    series: [
      {
        name: "Texts",
        data: chartData,
      },
    ],
    lang: {
      noData: "No Text Data",
    },
    noData: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };

  return (
    <div className="panel panel-default">
      <a
        href={
          Common.in_crm_mode() || window.IN_SCHEDULED_REPORT_MODE ? undefined : "/text_details/all"
        }
      >
        <div className="panel-heading">
          <div className="chart-title-container">
            <div className="chart-title-icon">
              <span className="fa fa-mobile" />
            </div>
            <div>
              <p className="chart-title-text">Total Texts Today</p>
              <p className="chart-title-count">{Common.formatNumberWithCommas(count)}</p>
            </div>
          </div>
        </div>
      </a>
      <div className="panel-body acquisition-summary-panel-body">
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        <div style={{ marginTop: "5px" }}>
          {Common.in_crm_mode() || window.IN_SCHEDULED_REPORT_MODE ? null : (
            <a href="/text_details/all">View all</a>
          )}
        </div>
      </div>
    </div>
  );
}

TotalTextsChart.propTypes = {
  data: PropTypes.array.isRequired,
  count: PropTypes.number.isRequired,
};

export default TotalTextsChart;
